import { z } from "zod";
import { linkTokenHashSchema } from "./linkTokenHashSchema";

export const ConfirmMagicLinkInputSchema = z.object({
    linkTokenHash: linkTokenHashSchema,
});

export type ConfirmMagicLinkInput = z.infer<typeof ConfirmMagicLinkInputSchema>;
